import type { SxProps } from './sxProps';

export function textColor(color?: string) {
  if (!color) return undefined;
  if (color === 'text.secondary') return 'rgba(0, 0, 0, 0.6)';
  if (color === 'text.primary') return 'rgba(0, 0, 0, 0.87)';
  if (color === 'error') return '#d32f2f';
  if (color === 'primary') return '#1976d2';
  if (color === 'inherit') return 'inherit';
  return color;
}

export const TYPOGRAPHY: Record<string, SxProps> = {
  h1: { fontSize: '6rem', fontWeight: 300, lineHeight: 1.167 },
  h2: { fontSize: '3.75rem', fontWeight: 300, lineHeight: 1.2 },
  h3: { fontSize: '3rem', fontWeight: 400, lineHeight: 1.167 },
  h4: { fontSize: '2.125rem', fontWeight: 400, lineHeight: 1.235 },
  h5: { fontSize: '1.5rem', fontWeight: 400, lineHeight: 1.334 },
  h6: { fontSize: '1.25rem', fontWeight: 500, lineHeight: 1.6 },
  subtitle1: { fontSize: '1rem', fontWeight: 400, lineHeight: 1.75 },
  subtitle2: { fontSize: '0.875rem', fontWeight: 500, lineHeight: 1.57 },
  body1: { fontSize: '1rem', fontWeight: 400, lineHeight: 1.5 },
  body2: { fontSize: '0.875rem', fontWeight: 400, lineHeight: 1.43 },
  caption: { fontSize: '0.75rem', fontWeight: 400, lineHeight: 1.66 },
  button: { fontSize: '0.875rem', fontWeight: 500, lineHeight: 1.75 },
  overline: { fontSize: '0.75rem', fontWeight: 400, lineHeight: 2.66, textTransform: 'uppercase' },
};

export const textReset: SxProps = { margin: 0, fontFamily: 'inherit' };
